import { PrivateApiClient } from "@sunrise/http-client";

import {
  endpoints,
  type ChannelGroup,
  type ChannelGroupsResponse,
} from "@sunrise/backend-types";

export async function fetchUserChannelGroups(
  privateApi: PrivateApiClient,
  host: string,
): Promise<ChannelGroup[]> {
  const response = await privateApi.get<ChannelGroupsResponse>(
    endpoints.userChannelGroups(host),
    {
      params: {
        group_type: "user",
      },
    },
  );

  return response.data.result;
}
